type SvgProps = React.SVGProps<SVGSVGElement>;

export const InkleTaxHelp = (props: SvgProps) => (
  <svg
    {...props}
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      fill="white"
    />
    <rect
      x="0.456522"
      y="0.456522"
      width="41.087"
      height="41.087"
      rx="20.5435"
      stroke="#F3F3F5"
      stroke-width="0.913043"
    />
    <g clip-path="url(#clip0_6719_7987)">
      <path
        d="M18.4891 19.4783H14.6848C13.6363 19.4783 12.7826 20.332 12.7826 21.3804V30.1304H20.3913V21.3804C20.3913 20.332 19.5376 19.4783 18.4891 19.4783ZM15.8261 28.6087H14.3043V27.087H15.8261V28.6087ZM15.8261 25.5652H14.3043V24.0435H15.8261V25.5652ZM18.8695 28.6087H17.3478V27.087H18.8695V28.6087ZM18.8695 25.5652H17.3478V24.0435H18.8695V25.5652ZM18.8695 22.5217H14.3043V21H18.8695V22.5217ZM28.7609 11.8696H19.813C20.1782 12.4144 20.3913 13.0687 20.3913 13.7717V14.913H31.0435V14.1522C31.0435 12.8914 30.0216 11.8696 28.7609 11.8696ZM18.8695 13.7717C18.8695 12.6563 17.9101 11.7653 16.7711 11.8795C15.7812 11.9784 15.0652 12.8853 15.0652 13.8805V17.9565H18.8695C20.5503 17.9565 21.913 19.3192 21.913 21V30.1304H25.7174C27.3981 30.1304 28.7609 28.7677 28.7609 27.087V16.4348H18.8695V13.7717Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6719_7987">
        <rect
          width="18.2609"
          height="18.2609"
          fill="white"
          transform="translate(12.7826 11.8696)"
        />
      </clipPath>
    </defs>
  </svg>
);
